<template>
    <div class="modal fade" id="shareModal" ref="shareModal" tabindex="-1" aria-labelledby="shareModal"
        aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered max-w-full tablet:!max-w-[90%] largeDesktop:!max-w-[1250px]">
            <div class="modal-content font-roboto">
                <div class="modal-body !p-3 !pb-[1rem] largeDesktop:!pb-[2rem]">
                    <div class="relative">
                        <button type="button"
                            class="absolute top-3 right-4 w-4 h-4 2xl:w-6 2xl:h-6 z-50 focus:!outline-none focus:!shadow-none"
                            data-bs-dismiss="modal" aria-label="Close" @click="hideshareModal()">
                            <font-awesome-icon icon="times" class="w-full h-full text-red-600" />
                        </button>
                        <div class="mb-2 2xl:mb-4 relative rounded-lg overflow-hidden mobile:h-[50px] largeDesktop::h-[60px]">
                            <img src="../../assets/images/shareModalBg.svg" alt="Background"
                                class="w-full mobile:h-[50px] largeDesktop:h-[60px] object-cover">
                            <div class="flex items-center gap-1 p-3 absolute top-0 left-0 w-full h-full">
                                <h4 class="text-xl m-0 font-roboto font-normal text-black-100 flex items-center gap-2">
                                    <img src="../../assets/images/Share-icon.png" alt="Share Icon"
                                        class="mobile:w-5 mobile:h-5 tablet:w-7 tablet:h-7">
                                    Share
                                </h4>
                            </div>
                        </div>
                        <div class="max-h-auto lg:max-h-[230px] 2xl:max-h-[400px] overflow-y-auto customScrollbar">
                            <div class="flex flex-wrap justify-center gap-4 p-2 ">
                                <template v-for="(items, index) in shareProtectionPlans" :key="index">
                                    <sharePlanCard :sharePlanDetail="items" @toggle="handleToggle" :reset="resetForm"/>
                                </template>
                            </div>
                        </div>
                        <div class="pt-3 mt-3 2xl:pt-5 2xl:mt-5 border-t border-[#CCCCCC]">
                            <sharePlanForm :selectedPlans="selectedPlans" @sendBtnClick="sendBtnClick" :reset="resetForm" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { Modal } from "bootstrap";
import sharePlanCard from "../../components/protectionPlansCards/sharePlanCard.vue";
import sharePlanForm from "../../components/protectionPlansCards/sharePlanForm.vue";
import { useToast } from "vue-toastification";
const toast = useToast();
export default {
    components: {
        sharePlanCard,
        sharePlanForm
    },
    data() {
        return {
            selectedPlans: [],
            resetForm: null
        };
    },
    computed: {
        ...mapGetters([
            "shareProtectionPlans",
            "sendProtectionPlanURLResponse"
        ]),
    },
    watch: {
        shareProtectionPlans: function (data) {
            if (this.shareProtectionPlans?.length > 0) {
                
                this.selectedPlans = []
                this.resetForm = new Date()
                const modalEl = this.$refs.shareModal;
                const modal = new Modal(modalEl);
                document.documentElement.style.overflow = 'hidden'; // Target HTML element
                if (window.innerWidth >= 992) {
                    document.documentElement.style.paddingRight = '15px';
                } else {
                    document.documentElement.style.paddingRight = '0px';
                }
                modal.show();
            }
            else {
                toast.error("Shared url not found");

            }
        },

        sendProtectionPlanURLResponse: function (data) {
            this.hideshareModal()
            toast.success("We’ve sent the Protection Plan link to the consumer’s phone and email.");
        },
    },
    methods: {
        ...mapActions([
            "getShareProtectionPlans",
            "sendShareProtectionPlanURL"
        ]),
        openModal() {
            this.getShareProtectionPlans({})
        },
        hideshareModal() {
            const modalEl = this.$refs.shareModal;
            if (modalEl) {
                const modal = Modal.getInstance(modalEl) || new Modal(modalEl);
                document.documentElement.style.overflow = '';
                document.documentElement.style.paddingRight = '0px';
                modal.hide();
            }
        },
        handleToggle({ item, checked }) {

            if (checked) {
                this.selectedPlans.push(item);
            } else {
                this.selectedPlans = this.selectedPlans.filter(p => p.plan_id != item.plan_id);
            }
        },
        sendBtnClick(payload) {
            this.sendShareProtectionPlanURL(payload)
        }
    }
}
</script>